import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
} from "react-native";
import makeRequest from "../components/makeRequest";
import { StackActions, useFocusEffect } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import ButtonLayout from "../components/ButtonLayoutMenu";
import LogoPublisher from "../components/LogoPublisher";
import { AsyncStorage } from "react-native";
import Constants from "expo-constants";
import * as Permissions from "expo-permissions";
import { Notifications } from "expo";

const registerForPushNotificationsAsync = async (push_token) => {
  return false;
};

export default function (props) {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [citas, setCitas] = useState([]);
  const week = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  const month = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const [instalaciones, setInstalaciones] = useState([]);

  useEffect(() => {
    const isAuth = async () => {
      const response = await makeRequest("users/me", "get");

      if (response[0] == 200) {
        let userInfoCopy = JSON.parse(JSON.stringify(userInfo));
        userInfoCopy.nombre = response[1].nombre;
        userInfoCopy.telefono = response[1].telefono;
        userInfoCopy.apellido = response[1].apellido;
        userInfoCopy.email = response[1].email;
        userInfoCopy._id = response[1]._id;
        registerForPushNotificationsAsync(userInfoCopy.push_token);

        setUserInfo(userInfoCopy);
        setLoading(false);
      }
    };
    isAuth();
    const loadInfo = async () => {
      const response = await makeRequest("instalaciones/user", "get");
      setInstalaciones(response[1]);
      const response2 = await makeRequest("citas", "get");
      setCitas(response2[1]);
    };
    loadInfo();
    if (props.route.params && props.route.params.userInfo)
      setUserInfo(props.route.params.userInfo);
  }, []);
  useEffect(() => {
    if (props.route.params && props.route.params.userInfo)
      setUserInfo(props.route.params.userInfo);
  }, [props.route.params]);

  return (
    <BackgroundUser scroll={true}>
      <Logo></Logo>
      <View style={{ flex: 1, justifyContent: "center" }}>
        {!loading ? (
          <View>
            <Title>Elija una opción</Title>
            <ButtonLayout
              text='Nueva cita'
              onPress={() =>
                props.navigation.navigate("NuevaCita", {
                  citas: citas,
                  userInfo: userInfo,
                  instalaciones: instalaciones,
                })
              }
            />
            <ButtonLayout
              text='Mis citas'
              onPress={() =>
                props.navigation.navigate("MisCitas", {
                  citas: citas,
                  userInfo: userInfo,
                  instalaciones: instalaciones,
                })
              }
            />
            <ButtonLayout
              text='Mis datos'
              onPress={() =>
                props.navigation.navigate("MisDatos", {
                  citas: citas,
                  userInfo: userInfo,
                  previous: "UserScreen",
                })
              }
            />
          </View>
        ) : (
          <ActivityIndicator size='large' color='rgba(255,255,255, 0.9)' />
        )}
      </View>
      <View style={{ justifyContent: "flex-end" }}>
        <LogoPublisher />
        <TouchableOpacity
          onPress={() => {
            const cerrarSesion = async () => {
              await AsyncStorage.removeItem("x-citaprevia-token");
              props.navigation.dispatch(StackActions.replace("UserLogin"));
            };
            cerrarSesion();
          }}>
          <Title
            style={{
              marginBottom: 20,
              fontSize: 17,
              textDecorationLine: "underline",
              textDecorationStyle: "solid",
              textDecorationColor: "#3E4672",
            }}>
            Cerrar sesión
          </Title>
        </TouchableOpacity>
      </View>
    </BackgroundUser>
  );
}
